<template>
  <a-spin :spinning="spinning">
    <a-tabs @change="changeTab" v-model="activeKey">
      <a-tab-pane
        :key="DownloadType.ReviewContent2"
        tab="保函预览"
        v-if="info.status === 3 && info.content_2 != ''"
      >
      </a-tab-pane>
      <a-tab-pane
        :key="DownloadType.ReviewContent"
        tab="合同预览"
        v-if="info.status === 3 && info.content != ''"
      >
      </a-tab-pane>
      <a-tab-pane
        :key="DownloadType.Content2"
        :tab="info.status === 5 || info.status === 7 || info.status === 13 ? '保函' : '保函（未签章）'"
        v-if="signurl.signurl2 && !isie"
      >
      </a-tab-pane>
      <a-tab-pane 
        :key="DownloadType.Content" 
        :tab="info.status === 5 || info.status === 7 || info.status === 13 ? '合同' : '合同（未签章）'"
        v-if="signurl.signurl && !isie"
      >
      </a-tab-pane>
      <a-tab-pane
        :key="DownloadType.Invoice"
        tab="发票"
        v-if="info.invoice && info.invoice.length > 0"
      >
      </a-tab-pane>
      <!-- <a-tab-pane :key="DownloadType.Voucher" tab="银行回单" v-if="bcdls.length > 0"> </a-tab-pane> -->
      <a-tab-pane :key="DownloadType.Agreement" tab="电子保函申请书" v-if="info.apply_pdf_src">
      </a-tab-pane>
      <a-tab-pane 
        :key="DownloadType.BiddingFile" 
        :tab="info.category_id === 2 ? '招标文件' : '中标通知书'" 
        v-if="info.bidding_file">
      </a-tab-pane>
      <a-tab-pane :key="DownloadType.ProjectContract" tab="项目合同" v-if="info.project_contract">
      </a-tab-pane>
      <a-tab-pane :key="DownloadType.OtherFile" tab="其他文件" v-if="info.other_file">
      </a-tab-pane>
    </a-tabs>
    <div class="pb-3" v-if="showDownloadButton">
      <a-button type="primary" @click="downloadFile(activeKey)">下载</a-button>
    </div>
    <!-- <div class="w-full" v-if="activeKey == DownloadType.License">
      <iframe :src="getUrl(activeKey)" style="width: 100%; height: 60vh"></iframe>
    </div> -->
    <div
      class="w-full"
      v-if="activeKey == DownloadType.ReviewContent2"
    >
      <content-preview :content="info.content_2" @pageset="(e) => pageset(e)"></content-preview>
    </div>
    <div
      class="w-full"
      v-if="activeKey == DownloadType.ReviewContent"
    >
      <content-preview :content="info.content" @pageset="(e) => pageset(e)"></content-preview>
    </div>
    <div
      class="w-full"
      v-if="activeKey == DownloadType.Content || activeKey == DownloadType.Content2"
    >
      <embed :src="getUrl(activeKey)" type="application/pdf" width="100%" :height="height" />
    </div>
    <!-- <template v-else-if="activeKey === DownloadType.Voucher">
      <div class="w-full" v-for="(b, index) in bcdls" :key="index">
        <iframe
          :src="`${$ossUrl}/pdfjs/build/web/viewer.html?file=${$ossUrl}${b.receipt_file_src}`"
          style="width: 100%; height: 60vh"
        ></iframe>
      </div>
    </template> -->
    <template v-else-if="activeKey === DownloadType.Invoice">
      <div v-for="(inv, index) in info.invoice" :key="index" class="w-full">
        <iframe
          :src="`${$ossUrl}/pdfjs/build/web/viewer.html?file=${$ossUrl}${inv.invoice_file_src}`"
          style="width: 100%; height: 60vh"
        ></iframe>
      </div>
    </template>
    <template v-else-if="activeKey === DownloadType.Agreement">
      <div class="w-full">
        <iframe
          :src="`${$ossUrl}/pdfjs/build/web/viewer.html?file=${$ossUrl}${info.apply_pdf_src}`"
          style="width: 100%; height: 60vh"
        ></iframe>
      </div>
    </template>
    <template v-else-if="activeKey === DownloadType.ProjectContract">
      <div class="flex justify-center">
        <embed
          v-if="info.project_contract.split('.').slice(-1)[0] == 'pdf'"
          :src="`${$ossUrl}${info.project_contract}`"
          type="application/pdf"
          width="100%"
          :height="height"
        />
        <img 
          v-else-if="isImageExtension(info.project_contract)"
          :src="`${$ossUrl}${info.project_contract}`"
          width="60%" 
        />
        <iframe
          v-else
          :src="`https://view.officeapps.live.com/op/view.aspx?src=${$ossUrl}${info.project_contract}`"
          type="application/pdf"
          width="100%"
          :height="height"
        ></iframe>
      </div>
    </template>
    <template v-else-if="activeKey === DownloadType.BiddingFile">
      <div class="flex justify-center">
        <embed
          v-if="info.bidding_file.split('.').slice(-1)[0] == 'pdf'"
          :src="`${$ossUrl}${info.bidding_file}`"
          type="application/pdf"
          width="100%"
          :height="height"
        />
        <img
          v-else-if="isImageExtension(info.bidding_file)"
          :src="`${$ossUrl}${info.bidding_file}`"
          width="60%" 
        />
        <iframe
          v-else
          :src="`https://view.officeapps.live.com/op/view.aspx?src=${$ossUrl}${info.bidding_file}`"
          type="application/pdf"
          width="100%"
          :height="height"
        ></iframe>
      </div>
    </template>
    <template v-else-if="activeKey === DownloadType.OtherFile">
      <div class="flex justify-center">
        <embed
          v-if="info.other_file.split('.').slice(-1)[0] == 'pdf'"
          :src="`${$ossUrl}${info.other_file}`"
          type="application/pdf"
          width="100%"
          :height="height"
        />
        <img 
          v-else-if="isImageExtension(info.other_file)"
          :src="`${$ossUrl}${info.other_file}`"
          width="60%" 
        />
        <iframe
          v-else
          :src="`https://view.officeapps.live.com/op/view.aspx?src=${$ossUrl}${info.other_file}`"
          type="application/pdf"
          width="100%"
          :height="height"
        ></iframe>
      </div>
    </template>
  </a-spin>
</template>
<script>
  import { config } from '@/api/config';
  import { download, downloadUrl } from '@/utils/download';
  import { isIE } from '@/utils/tool';
  import ContentPreview from '@/components/ContentPreview/index';
  import { transContentNoday } from '@/utils/transContent';
  export default {
    components: {
      ContentPreview
    },
    props: {
      info: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        DownloadType: {
          Content2: 1,
          Content: 2,
          Invoice: 3,
          License: 4,
          Voucher: 5,
          Agreement: 6,
          ProjectContract: 7,
          BiddingFile: 8,
          OtherFile: 9,
          ReviewContent2: 10,
          ReviewContent: 11,
        },
        spinning: false,
        setting: {},
        activeKey: null,
        isie: isIE(),
        height: 841,
        page: 0
      };
    },
    computed: {
      signurl() {
        return this.info.status == 5 || this.info.status == 7 || this.info.status == 13
          ? {
              signurl: this.info.sign_file_path,
              signurl2: this.info.sign_file_path2,
            }
          : { signurl: this.info.file_path, signurl2: this.info.file_path2 };
      },
      bcdls() {
        let bcdlarray = [];
        if (this.info.bcdl) {
          for (let i of this.info.bcdl) {
            if (i.receipt_file_src) {
              bcdlarray.push(i);
            }
          }
        }
        return bcdlarray;
      },
      firstVisibleTabKey() {
        if (this.info.status === 3 && this.info.content_2 != '') {
          return this.DownloadType.ReviewContent2;
        }
        if (this.info.status === 3 && this.info.content != '') {
          return this.DownloadType.ReviewContent;
        }
        if (this.signurl.signurl2 && !this.isie) {
          return this.DownloadType.Content2;
        }
        if (this.signurl.signurl && !this.isie) {
          return this.DownloadType.Content;
        }
        if (this.info.invoice && this.info.invoice.length > 0) {
          return this.DownloadType.Invoice;
        }
        if (this.info.apply_pdf_src) {
          return this.DownloadType.Agreement;
        }
        if (this.info.bidding_file) {
          return this.DownloadType.BiddingFile;
        }
        if (this.info.project_contract) {
          return this.DownloadType.ProjectContract;
        }
        if (this.info.other_file) {
          return this.DownloadType.OtherFile;
        } 
        return null;
      },
      showDownloadButton() {
        const hasVisibleTabs = this.firstVisibleTabKey !== null;
        const isReviewContent2Tab = this.activeKey === this.DownloadType.ReviewContent2;
        const isReviewContentTab = this.activeKey === this.DownloadType.ReviewContent;
        return hasVisibleTabs && !isReviewContent2Tab && !isReviewContentTab;
      },
    },
    watch: {
      info: {
        handler(a) {
          if (a.status === 3) {
            this.info.content_2 = this.getContent2(this.info);
            this.info.content = this.getContent(this.info);
          }
          this.activeKey = this.firstVisibleTabKey;
        },
        immediate: true,
      },
    },
    mounted() {
      this.getConfig();
    },
    methods: {
      async getConfig() {
        this.setting = (await config()) || {};
      },
      getContent2(info) {
        var content2Temp = (info.projects && info.projects.content_2) || (info.temp && info.temp.content_2);
        let c = '';
        if (content2Temp) {
          c = transContentNoday(content2Temp, info);
        }
        return c;
      },
      getContent(info) {
        var contentTemp = (info.projects && info.projects.content) || (info.temp && info.temp.content);
        let c = '';
        if (contentTemp) {
          c = transContentNoday(contentTemp, info);
        }
        return c;
      },
      pageset(p) {
        this.page = p;
      },
      async downloadFile(type) {
        this.spinning = true;
        let tabName;
        switch (type) {
          case this.DownloadType.Content:
            await download(this.info, 0);
            break;
          case this.DownloadType.Content2:
            await download(this.info, 1);
            break;
          case this.DownloadType.Invoice:
            for (let i of this.info.invoice) {
              await downloadUrl(
                this.$ossUrl + i.invoice_file_src,
                `发票-${this.info.bidder}-${this.info.prefix}${this.info.code}-${i.invoiceSerialNum}.pdf`,
              );
            }
            break;
          case this.DownloadType.License:
            await downloadUrl(this.$ossUrl + this.setting.financing_license_src, `融资证照.pdf`);
            break;
          case this.DownloadType.Voucher:
            for (let i = 0; i < this.bcdls.length; i++) {
              await downloadUrl(
                this.$ossUrl + this.bcdls[i].receipt_file_src,
                `银行回单-${this.info.bidder}-${this.info.prefix}${this.info.code}-${i}.pdf`,
              );
            }
            break;
          case this.DownloadType.Agreement:
            await downloadUrl(
              this.$ossUrl + this.info.apply_pdf_src,
              `保函申请书-${this.info.bidder}-${this.info.prefix}${this.info.code}.pdf`,
            );
            break;
          case this.DownloadType.ProjectContract:
            await downloadUrl(
              this.$ossUrl + this.info.project_contract,
              `项目合同-${this.info.project}-${this.info.prefix}${this.info.code}`,
            );
            break;
          case this.DownloadType.BiddingFile:
            tabName = this.info.category_id === 2 ? '招标文件' : '中标通知书';
            await downloadUrl(
              this.$ossUrl + this.info.bidding_file,
              `${tabName}-${this.info.bidder}-${this.info.prefix}${this.info.code}`,
            );
            break;
          case this.DownloadType.OtherFile:
            await downloadUrl(
              this.$ossUrl + this.info.other_file,
              `其他文件-${this.info.prefix}${this.info.code}-${this.info.other_file_name}`,
            );
            break;
        }
        this.spinning = false;
      },
      isImageExtension(filePath) {
        const extension = filePath.split('.').slice(-1)[0];
        return ['jpg', 'jpeg', 'png'].includes(extension);
      },
      getUrl(type) {
        let url = this.$ossUrl + '/pdfjs/build/web/viewer.html?file=' + this.$ossUrl;
        switch (type) {
          case this.DownloadType.Content:
            url = this.$ossUrl + this.signurl.signurl;
            break;
          case this.DownloadType.Content2:
            url = this.$ossUrl + this.signurl.signurl2;
            break;
          case this.DownloadType.Invoice:
            break;
          case this.DownloadType.License:
            url += this.setting.financing_license_src;
            break;
          case this.DownloadType.Voucher:
            break;
        }
        return url;
      },
      changeTab(key) {
        this.activeKey = key;
      },
    },
  };
</script>
<style lang="less" scoped></style>
